export const FONTSIZE = [
  { size: 8, name: "FONTSIZE_EIGHT" },
  { size: 9, name: "FONTSIZE_NINE" },
  { size: 10, name: "FONTSIZE_TEN" },
  { size: 11, name: "FONTSIZE_ELEVEN" },
  { size: 12, name: "FONTSIZE_TWELVE" },
  { size: 14, name: "FONTSIZE_FOURTEEN" },
  { size: 16, name: "FONTSIZE_SIXTEEN" },
  { size: 18, name: "FONTSIZE_EIGHTEEN" },
  { size: 24, name: "FONTSIZE_TWENTYFOUR" },
  { size: 30, name: "FONTSIZE_THIRTY" },
  { size: 36, name: "FONTSIZE_THIRTYSIX" },
  { size: 48, name: "FONTSIZE_FOURTYEIGHT" },
  { size: 60, name: "FONTSIZE_SIXTY" },
  { size: 72, name: "FONTSIZE_SEVENTYTWO" },
  { size: 96, name: "FONTSIZE_NINTYSIX" },
  { size: 120, name: "FONTSIZE_ONEHUNDREDTWENTY" },
  { size: 144, name: "FONTSIZE_ONEHUNDREDFOURTYFOUR" },
];

export const findClosestSize = x =>
  FONTSIZE.reduce((prev, curr) =>
    Math.abs(curr.size - x) <= Math.abs(prev.size - x) ? curr : prev,
  );
